import { Action, CLOSE_SIDEBAR, OPEN_SIDEBAR } from './actions';
import { initialState, SidebarType } from './types';

export const reducer = (
	state: SidebarType = initialState,
	action: Action
): SidebarType => {
	switch (action.type) {
		case OPEN_SIDEBAR: {
			return {
				...state,
				sideBarType: action.sideBarType,
				params: action.params,
				isOpen: true,
			};
		}
		case CLOSE_SIDEBAR:
			return initialState;
		default:
			return state;
	}
};
